import { iUsuario } from "../interfaces/bonita/usuario";
import { Auth, userTest } from "../interfaces/auth/user";
import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import { iComment } from "../interfaces/bonita/comment";
import { iListTaskHumanCompleteUser } from "../interfaces/bonita/listTaskHumanCompleteUser";
import rootReducer from "./rootReducers";
import { TypeStatus } from "./helpers/constantes";
export interface AppStore {
  currentUser: iUsuario;
  userTest: userTest;
  comment: iComment[];
  allTask: iListTaskHumanCompleteUser[];
  usuarioActivo: iUsuario;
  initialState: InitialState;
  user: Auth;
  listCaseActive: any[];
  listtaskHistoryHumanOpen: any[];
  lisTaskHumanComplete: any[];
}
export const initialUsuario: iUsuario = {
  copyright: "",
  is_guest_user: "",
  branding_version: "",
  branding_version_with_date: "",
  user_id: "",
  user_name: "",
  session_id: "",
  conf: "",
  is_technical_user: "",
  version: "",
};

interface InitialState {
  user: iUsuario;
  status: TypeStatus;
  error: string | null;
}

const persistConfig = {
  key: "root",
  version: 1,
  storage: storage, // storageSession,
  //whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type Dispatch = typeof store.dispatch;
export type Thunk = ThunkAction<
  Promise<unknown>,
  RootState,
  unknown,
  Action<unknown>
>;

export default store;
